import PollEv from '@polleverywhere/core/helpers/core.js'

window.PollEv = PollEv
